//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React, { useState } from 'react';

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';
import { ContentLibraryFilter } from '@apis/content-library/contentLibraryApiModel';
import { PrimaryLinkButton } from '@components/atoms/button/Button';
import {
  FilterSection,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { ContentDrawerTrackingIds } from '@content-drawer/contentDrawerConstants';
import { AllLabelsPanel } from '@content-drawer/filters/labels/AllLabelsPanel';

export interface AllLabelsDialogProps {
  // TODO: Remove hideManageLabels once moderator label management is supported.
  hideManageLabels?: boolean;
  moderatorLabelsQuery?: ContentLibraryFilter;
  onChange: (
    sections: Map<MediaFilterParamKey, FilterSection<FilterValue>>,
  ) => void;
  section: FilterSection<string>;
  useModeratorLabels?: boolean;
}

export const AllLabelsDialog = ({
  hideManageLabels,
  moderatorLabelsQuery,
  onChange,
  section,
  useModeratorLabels,
}: AllLabelsDialogProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <PrimaryLinkButton
        onClick={() => setIsOpen(true)}
        trackingId={ContentDrawerTrackingIds.OPEN_ALL_LABELS_MODAL}
      >
        View All
      </PrimaryLinkButton>

      {isOpen && (
        <AllLabelsPanel
          hideManageLabels={hideManageLabels}
          isOpen={isOpen}
          moderatorLabelsQuery={moderatorLabelsQuery}
          onChange={onChange}
          onClose={() => setIsOpen(false)}
          section={section}
          useModeratorLabels={useModeratorLabels}
        />
      )}
    </>
  );
};
